import LowPriorityIcon from '@mui/icons-material/LowPriority';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { lighten } from 'polished';
import { defineMessage, useIntl } from 'react-intl';
import { useTranscriptionInteractionsStore } from '../hooks/useTranscriptionInteractionsStore';

const syncTooltipOnMessage = defineMessage({
  id: 'fragments.transcription.v2.syncTooltipOn',
  defaultMessage: 'Sincronizar transcripción con reproducción: activado',
});

const syncTooltipOffMessage = defineMessage({
  id: 'fragments.transcription.v2.syncTooltipOff',
  defaultMessage: 'Sincronizar transcripción con reproducción: desactivado',
});

/**
 * Renders the sync-to-playback action with dynamic active/inactive styling.
 */
export function TranscriptionSyncAction() {
  const theme = useTheme();
  const { $t } = useIntl();
  const followPlayback = useTranscriptionInteractionsStore((state) => state.followPlayback);
  const onSyncIconClick = useTranscriptionInteractionsStore((state) => state.onSyncIconClick);

  const syncIconButton = (
    <IconButton
      size="small"
      color={followPlayback ? 'success' : 'secondary'}
      sx={{
        bgcolor: followPlayback ? lighten(0.45, theme.palette.success.light) : undefined,
      }}
      onClick={() => {
        if (!followPlayback) {
          onSyncIconClick();
        }
      }}
    >
      <LowPriorityIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Tooltip
      placement="top"
      title={followPlayback ? $t(syncTooltipOnMessage) : $t(syncTooltipOffMessage)}
    >
      {syncIconButton}
    </Tooltip>
  );
}
